import React, { Component } from 'react';

import CamdetectCamerasModel from './CamdetectCamerasModel';

import { Spin } from 'antd';

class CamdetectLazyImage extends Component {

    state = {
        image: null,
        imageString: this.props.imageString
    }
    componentWillMount() {
        if (this.props.imageString != '-') {
            CamdetectCamerasModel.getImageString(this.props.imageString)
                .then((res) => {
                    if (res != '-') {
                        this.setState({ image: 'data:image/png;base64,' + res })
                    } else {
                        this.setState({ image: '-', imageString: '-' })
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
        }
    }
    render() {
        return (
            <div>
                {(this.state.image && this.state.image != '-') ? <img src={this.state.image} width="auto" height="auto" alt="previewImage" /> : this.state.imageString != '-' ? <Spin /> : '-'}
            </div>
        );
    }
}

export default CamdetectLazyImage;


// WEBPACK FOOTER //
// ./src/components/CamdetectLazyImage.js